import React from 'react';
import DropdownMenu from './DropdownMenu';
import DropdownMenuItem from './DropdownMenuItem';
import classnames from 'classnames';

const options = [
  {
    label: 'All guests',
    value: 'ALL',
    className: 'campaign_dropdown',
  },
  {
    label: 'New guests',
    value: 'NEW',
    className: 'campaign_dropdown',
  },
  {
    label: 'Existing guests',
    value: 'EXISTING',
    className: 'campaign_dropdown',
  },
];
const StatusSelectDropdown = ({
  onChange,
  selectedOption,
  dropdownMenu,
  ...rest
}) => {
  return (
    <DropdownMenu {...rest}>
      {/* eslint react/no-array-index-key: "off" */
      options.map((item, index) => {
        return (
          <DropdownMenuItem
            label={item.label}
            key={index}
            value={item.value}
            onClick={onChange}
            type="BUTTON"
            className={classnames(item.className,{'active':selectedOption===item.value})}
          />
        );
      })}
    </DropdownMenu>
  );
  //}
};

export default StatusSelectDropdown;
